module.exports = __webpack_public_path__ + "img/mave-icon.ef65404c.svg";